import { HTMLAttributes } from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';

type PageLayoutWrapperProps = HTMLAttributes<HTMLDivElement>;

const PageLayoutWrapper = (props: PageLayoutWrapperProps) => {
  const { className, children } = props;

  return (
    <Box className={clsx('prose mx-auto flex w-full flex-col', className)}>
      {children}
    </Box>
  );
};

export default PageLayoutWrapper;
